import useLang from '@/utils/useLang'

const useLocalePath = () => {
  const lang = useLang()

  const getLocalePath = (path: string) => {
    return `/${lang.slice(0, 2)}${path}`
  }

  return {
    getLocalePath
  }
}

export default useLocalePath
